import { render, staticRenderFns } from "./announcement-list.vue?vue&type=template&id=bfe0169c&"
import script from "./js/announcement-list.js?vue&type=script&lang=js&"
export * from "./js/announcement-list.js?vue&type=script&lang=js&"
import style0 from "./announcement-list.vue?vue&type=style&index=0&id=bfe0169c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports